import { HomePage } from "./HomePage";
import { NotAuthorizedPage } from "./NotAuthorizedPage";
import { NotFoundPage } from "./NotFoundPage";
import { WatchesPage } from "./WatchesPage";
import { AddWatchPage } from "./AddWatchPage";
import { UserPage } from "./UserPage";
import { EditUserPage } from "./EditUserPage";
import { VendorsPage } from "./VendorsPage";
import { HeaderPage } from "./HeaderPage";
import { AliasPage } from "./AliasPage";
import { UrlStubsPage } from "./UrlStubsPage";
import { CouponsPage } from "./CouponsPage";
import { AccountsPage } from "./AccountsPage";
import { AccountDetailPage } from "./AccountDetailPage";
import { TradeRequestsPage } from "./TradeRequestsPage";
import { TradeInsPage } from "./TradeInsPage";
import { TradeInDetailPage } from "./TradeInDetailPage";
import { SalesPage } from "./SalesPage";
import {
  HomeSliderPage,
  HomeBrandTilesPage,
  HomeLogoStripPage,
  HomeCollectionsPage,
} from "./HomePageBlocksPage";
import { OrdersPage } from "./OrdersPage";
import { OrderDetailPage } from "./OrderDetailPage";
import { OrderHistoryPage } from "./OrderHistoryPage";
import { OrderSearchPage } from "./OrderSearchPage";
import { RepairsPage } from "./RepairsPage";
import { RepairDetailPage } from "./RepairDetailPage";
import { ReturnsPage } from "./ReturnsPage";
import { ReturnDetailPage } from "./ReturnDetailPage";
import { OrderNewPage } from "./OrderNewPage";
import {
  REACT_APP_HOME_SLIDER_ENABLED,
  REACT_APP_OPERATIONS_ENABLED,
  REACT_APP_SITE_HEADER_ENABLED,
} from "../../config";
import { TradeInBrandsPage } from "./TradeInBrandsPage";
import { MagentoSyncPage } from "./MagentoSyncPage";
import { MagentoSyncDetailPage } from "./MagentoSyncDetailPage";
import { MagentoSyncDayPage } from "./MagentoSyncDayPage";
import { WatchesPullPage } from "./WatchesPullPage";
import { WatchfinderSyncPage } from "./WatchfinderSyncPage";
import { MassUpdatePage } from "./MassUpdatePage";
import { MassPriceUpdatePage } from "./MassPriceUpdatePage";
import { WatchHistory } from "./Components/WatchHistory";
import { WatchAttributes } from "./Components/watchDetailTable/WatchAttributes";
import { SiteAttributes } from "./Components/watchDetailTable/SiteAttributes";
import { RecordsPage } from "./Components/watchDetailTable/RecordsPage";
import { ShippingSiteAttributes } from "./Components/watchDetailTable/ShippingSiteAttributes";
import { WatchAttributesAffiliated } from "./Components/watchDetailTable/WatchAttributesAffiliated";
import { MovementAttributes } from "./Components/watchDetailTable/MovementAttributes";
import { WatchAttributesGroups } from "./Components/watchDetailTable/WatchAttributesGroups";
import { WatchDetails } from "./Components/watchDetailTable/WatchDetails";
import { MovementDetails } from "./Components/watchDetailTable/MovementDetails";
import { ShippingDetails } from "./Components/watchDetailTable/ShippingDetails";
import { WatchDetailsSeo } from "./Components/watchDetailTable/WatchDetailsSeo";
import { WatchDetailsTabs } from "./Components/watchDetailTable/WatchDetailsTabs";
import { WatchDetailsGroups } from "./Components/watchDetailTable/WatchDetailsGroups";
import { WatchAttributesFinishTabs } from "./Components/watchDetailTable/WatchAttributesFinishTabs";

export * from "./Components/watchDetailTable/ConfirmDialog";
export * from "./Components/watchDetailTable/ConfirmButton";

export const MainPages = {
  home: {
    anon: false,
    path: "/",
    title: "Home",
    type: "PAGE_HOME",
    view: HomePage,
  },
  watchesList: {
    anon: false,
    path: "/watches-list",
    title: "Watches Lit",
    type: "PAGE_WATCHES_LIST",
    view: WatchesPage,
  },
  addWatch: {
    anon: false,
    path: "/add-watch",
    title: "Add Watches",
    type: "PAGE_ADD_WATCH",
    view: AddWatchPage,
  },

  editWatch: {
    anon: false,
    path: "/edit-watch/:id",
    title: "Edit Watches",
    type: "PAGE_EDIT_WATCH",
    view: AddWatchPage,
  },
  history: {
    anon: false,
    path: "/history/:id",
    title: "History",
    type: "HISTORY",
    view: WatchHistory,
  },
  WatchAttributes: {
    anon: false,
    path: "/watch-attributes/:attribute",
    title: "Watch Attributes",
    type: "WATCH_ATTRIBUTES",
    view: WatchAttributes,
  },
  Records: {
    anon: false,
    path: "/records",
    title: "Records",
    type: "RECORDS",
    view: RecordsPage,
  },
  SiteAttributes: {
    anon: false,
    path: "/manage-site-attributes/:attribute",
    title: "Site Attributes",
    type: "SITE_ATTRIBUTES",
    view: SiteAttributes,
  },
  ShippingSiteAttributes: {
    anon: false,
    path: "/manage-shipping-tiers/:attribute",
    title: "Ship Attributes",
    type: "SHIP_ATTRIBUTES",
    view: ShippingSiteAttributes,
  },
  WatchAttributeGroups: {
    anon: false,
    path: "/watch-attribute-groups/:attribute",
    title: "Watch Attribute Groups",
    type: "WATCH_ATTRIBUTE_GROUPS",
    view: WatchAttributesGroups,
  },
  WatchAttributesAffiliated: {
    anon: false,
    path: "/watch-attribute-affiliated/:attribute",
    title: "Watch Attribute Groups",
    type: "WATCH_ATTRIBUTE_AFFILIATED",
    view: WatchAttributesAffiliated,
  },
  MovementAttributes: {
    anon: false,
    path: "/movement-attribute/:attribute",
    title: "Movement Attribute",
    type: "MOVEMENT_ATTRIBUTE_AFFILIATED",
    view: MovementAttributes,
  },
  ShippingDetails: {
    anon: false,
    path: "/shipping-details/:attribute/:detail/:id/",
    title: "Shipping Details",
    type: "SHIPPING_DETAILS",
    view: ShippingDetails,
  },
  MovementDetails: {
    anon: false,
    path: "/movement-details/:attribute/:detail/:id/",
    title: "Movement Details",
    type: "MOVEMENT_DETAILS_BRANDS",
    view: MovementDetails,
  },
  MovementDetailsBrands: {
    anon: false,
    path: "/movement-details/:attribute/:detail/:brand/:id/",
    title: "Movement Details",
    type: "MOVEMENT_DETAILS",
    view: MovementDetails,
  },
  WatchAttributesFinishTabs: {
    anon: false,
    path: "/watch-attributes-finish",
    title: "Hands & Hour Marker Finish",
    type: "WATCH_ATTRIBUTES_FINISH_TABS",
    view: WatchAttributesFinishTabs,
  },
  WatchDetails: {
    anon: false,
    path: "/watch-details/:attribute/:detail/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS",
    view: WatchDetails,
  },
  WatchDetailsSeo: {
    anon: false,
    path: "/watch-details-seo/:attribute/:detail/:id/:brand_id",
    title: "Watch Details",
    type: "WATCH_DETAILS_SEO",
    view: WatchDetailsSeo,
  },
  WatchDetailsTabs: {
    anon: false,
    path: "/watch-details-tabs/:attribute/:detail/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_TABS",
    view: WatchDetailsTabs,
  },
  WatchDetailsGroups: {
    anon: false,
    path: "/watch-details-groups/:attribute/:detail/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_GROUPS",
    view: WatchDetailsGroups,
  },
  WatchDetailsBrands: {
    anon: false,
    path: "/watch-details/:attribute/:detail/:brand/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_BRANDS",
    view: WatchDetails,
  },
  WatchDetailsSeoBrands: {
    anon: false,
    path: "/watch-details-seo/:attribute/:detail/:id/:brand/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_SEO_BRANDS",
    view: WatchDetailsSeo,
  },
  WatchDetailsTabsBrands: {
    anon: false,
    path: "/watch-details-tabs/:attribute/:detail/:brand/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_TABS_BRANDS",
    view: WatchDetailsTabs,
  },
  WatchDetailsGroupsBrands: {
    anon: false,
    path: "/watch-details-groups/:attribute/:detail/:brand/:id/",
    title: "Watch Details",
    type: "WATCH_DETAILS_GROUPS_BRANDS",
    view: WatchDetailsGroups,
  },
  notAuthorized: {
    anon: true,
    layout: null,
    path: "/unauthorized",
    title: "Not Authorized",
    type: "PAGE_NOT_AUTHORIZED",
    view: NotAuthorizedPage,
  },
  notFound: {
    anon: true,
    layout: null,
    path: "*",
    title: "Page Not Found",
    type: "PAGE_NOT_FOUND",
    view: NotFoundPage,
  },
  vendors: {
    anon: false,
    path: "/vendors",
    title: "Vendors",
    type: "PAGE_VENDORS",
    view: VendorsPage,
  },
  // PT only. TPC's storefront has no header strip, so the fork turns this off
  // and the route stops existing rather than sitting there unreachable.
  ...(REACT_APP_SITE_HEADER_ENABLED
    ? {
        siteHeader: {
          anon: false,
          path: "/site-header",
          title: "Header / Banner",
          type: "PAGE_SITE_HEADER",
          view: HeaderPage,
        },
      }
    : {}),
  aliases: {
    anon: false,
    path: "/search-aliases",
    title: "Search Aliases",
    type: "PAGE_SEARCH_ALIASES",
    view: AliasPage,
  },
  urlStubs: {
    anon: false,
    path: "/url-stubs",
    title: "URL Stubs",
    type: "PAGE_URL_STUBS",
    view: UrlStubsPage,
  },
  // Orders. TPC only for now; PT carries the code with the flag off. The
  // detail route is registered before nothing else claims /orders/:id.
  ...(REACT_APP_OPERATIONS_ENABLED
    ? {
        orders: {
          anon: false,
          path: "/orders",
          title: "Orders",
          type: "PAGE_ORDERS",
          view: OrdersPage,
        },
        // Both of these must precede /orders/:id, which would otherwise
        // swallow them as an id.
        orderNew: {
          anon: false,
          path: "/orders/new",
          title: "New Order",
          type: "PAGE_ORDER_NEW",
          view: OrderNewPage,
        },
        orderSearch: {
          anon: false,
          path: "/orders/search",
          title: "Search Orders",
          type: "PAGE_ORDER_SEARCH",
          view: OrderSearchPage,
        },
        // More specific path first — /orders/:id would otherwise swallow it.
        orderHistory: {
          anon: false,
          path: "/orders/:id/history",
          title: "Order History",
          type: "PAGE_ORDER_HISTORY",
          view: OrderHistoryPage,
        },
        orderDetail: {
          anon: false,
          path: "/orders/:id",
          title: "Order",
          type: "PAGE_ORDER_DETAIL",
          view: OrderDetailPage,
        },
        // Customer service. Same flag: these read the order tables too, and a
        // return completing moves the order it belongs to.
        repairs: {
          anon: false,
          path: "/repairs",
          title: "Repairs",
          type: "PAGE_REPAIRS",
          view: RepairsPage,
        },
        repairDetail: {
          anon: false,
          path: "/repairs/:id",
          title: "Repair",
          type: "PAGE_REPAIR_DETAIL",
          view: RepairDetailPage,
        },
        returns: {
          anon: false,
          path: "/returns",
          title: "Returns & Exchanges",
          type: "PAGE_RETURNS",
          view: ReturnsPage,
        },
        returnDetail: {
          anon: false,
          path: "/returns/:id",
          title: "Return",
          type: "PAGE_RETURN_DETAIL",
          view: ReturnDetailPage,
        },
        coupons: {
          anon: false,
          path: "/coupons",
          title: "Coupons",
          type: "PAGE_COUPONS",
          view: CouponsPage,
        },
        accounts: {
          anon: false,
          path: "/accounts",
          title: "Accounts",
          type: "PAGE_ACCOUNTS",
          view: AccountsPage,
        },
        accountDetail: {
          anon: false,
          path: "/accounts/:id",
          title: "Account",
          type: "PAGE_ACCOUNT_DETAIL",
          view: AccountDetailPage,
        },
        tradeRequests: {
          anon: false,
          path: "/trade-requests",
          title: "Trade Step 1",
          type: "PAGE_TRADE_REQUESTS",
          view: TradeRequestsPage,
        },
        tradeIns: {
          anon: false,
          path: "/trade-ins",
          title: "Trade Step 2",
          type: "PAGE_TRADE_INS",
          view: TradeInsPage,
        },
        tradeInDetail: {
          anon: false,
          path: "/trade-ins/:id",
          title: "Trade-In",
          type: "PAGE_TRADE_IN_DETAIL",
          view: TradeInDetailPage,
        },
        sales: {
          anon: false,
          path: "/sales",
          title: "Sales",
          type: "PAGE_SALES",
          view: SalesPage,
        },
      }
    : {}),
  // Manage Site > Home Page. TPC only for now; PT carries the code with the
  // flag off, so the routes simply do not exist there. One screen behind all
  // four — they differ in labels and fields, not behaviour.
  ...(REACT_APP_HOME_SLIDER_ENABLED
    ? {
        homeSlider: {
          anon: false,
          path: "/home-slider",
          title: "Main Slider",
          type: "PAGE_HOME_SLIDER",
          view: HomeSliderPage,
        },
        homeBrandTiles: {
          anon: false,
          path: "/home-brand-tiles",
          title: "Brand Tiles",
          type: "PAGE_HOME_BRAND_TILES",
          view: HomeBrandTilesPage,
        },
        homeLogoStrip: {
          anon: false,
          path: "/home-logo-strip",
          title: "Logo Strip",
          type: "PAGE_HOME_LOGO_STRIP",
          view: HomeLogoStripPage,
        },
        homeCollections: {
          anon: false,
          path: "/home-collections",
          title: "Featured Collections",
          type: "PAGE_HOME_COLLECTIONS",
          view: HomeCollectionsPage,
        },
      }
    : {}),
  tradeInBrands: {
    anon: false,
    path: "/trade-in-brands",
    title: "Trade-In Brands",
    type: "PAGE_TRADE_IN_BRANDS",
    view: TradeInBrandsPage,
  },
  magentoSync: {
    anon: false,
    path: "/magento-sync",
    title: "Magento Sync",
    type: "PAGE_MAGENTO_SYNC",
    view: MagentoSyncPage,
  },
  watchesPull: {
    anon: false,
    path: "/watches-pull",
    title: "Watches Pull Endpoints",
    type: "PAGE_WATCHES_PULL",
    view: WatchesPullPage,
  },
  watchfinderSync: {
    anon: false,
    path: "/watchfinder-sync",
    title: "Watchfinder Sync",
    type: "PAGE_WATCHFINDER_SYNC",
    view: WatchfinderSyncPage,
  },
  magentoSyncDay: {
    anon: false,
    path: "/magento-sync/day/:date",
    title: "Magento Sync Day",
    type: "PAGE_MAGENTO_SYNC_DAY",
    view: MagentoSyncDayPage,
  },
  magentoSyncDetail: {
    anon: false,
    path: "/magento-sync/:run_id",
    title: "Magento Sync Detail",
    type: "PAGE_MAGENTO_SYNC_DETAIL",
    view: MagentoSyncDetailPage,
  },
  massUpdate: {
    anon: false,
    path: "/mass-update",
    title: "Mass Warranty/API Update",
    type: "PAGE_MASS_UPDATE",
    view: MassUpdatePage,
  },
  massPriceUpdate: {
    anon: false,
    path: "/mass-price-update",
    title: "Mass Price Update",
    type: "PAGE_MASS_PRICE_UPDATE",
    view: MassPriceUpdatePage,
  },
  addUser: {
    anon: false,
    path: "/manage-users",
    title: "Manage User",
    type: "PAGE_MANAGE_USER",
    view: UserPage,
  },
  editUser: {
    anon: false,
    path: "/edit-user/:id",
    title: "Edit User",
    type: "PAGE_EDIT_USER",
    view: EditUserPage,
  },
};
export default MainPages;

export const MainArea = {
  pages: MainPages,
};
